export default {
  MESSAGES: 'MESSAGES',
  OPENED_MESSAGES: 'OPENED_MESSAGES',
  CLOSED_MESSAGES: 'CLOSED_MESSAGES',
  STATUS_MESSAGES: 'STATUS_MESSAGES',
  TOTAL: 'TOTAL',
  READ_TOTAL: 'READ_TOTAL',
  UNREAD_TOTAL: 'UNREAD_TOTAL',
  MESSAGES_DETAIL: 'MESSAGES_DETAIL',
  MESSAGE_TYPE: 'MESSAGE_TYPE',
  MESSAGE_BODY: 'MESSAGE_BODY',
  MESSAGE_ARTICLES: 'MESSAGE_ARTICLES',
  MESSAGE_DATE: 'MESSAGE_DATE',
  MESSAGE_FROM_EMAIL: 'MESSAGE_FROM_EMAIL',
  MESSAGE_FROM_NAME: 'MESSAGE_FROM_NAME',
  MESSAGE_TITLE: 'MESSAGE_TITLE',
  MESSAGE_READ: 'MESSAGE_READ',
  MESSAGE_ARCHIVED: 'MESSAGE_ARCHIVED',
  MESSAGE_PRIORITY: 'MESSAGE_PRIORITY',
  MESSAGE_UID: 'MESSAGE_UID',
  MESSAGE_TICKET_ID: 'MESSAGE_TICKET_ID',
  MESSAGE_STATUS: 'MESSAGE_STATUS',
  MESSAGE_PREVIEW_DATA: 'MESSAGE_PREVIEW_DATA',
}
